/*
------------------------------------------------
Delishop Framework
Routine Delishop
Version: 1.0
Compatible: Shrine Pro 1.5.4
------------------------------------------------
*/

(function () {

    function initRoutine(section) {

        if (!section) return;

        // Reservado para futuras mejoras.

    }

    document.addEventListener("DOMContentLoaded", function () {

        document
            .querySelectorAll(".dh-routine")
            .forEach(initRoutine);

    });

    document.addEventListener("shopify:section:load", function (event) {

        const section = event.target.querySelector(".dh-routine");

        if (section) {

            initRoutine(section);

        }

    });

})();